import { SeparatorContainer } from "./styles";

const Separator = () => {
    return (
        <SeparatorContainer />
    )
} 

export default Separator;